
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const steps = [
  {
    number: '01',
    title: 'Keşif',
    description: 'Markanızı, hedeflerinizi ve kitlenizi derinlemesine anlıyoruz.',
  },
  {
    number: '02',
    title: 'Strateji',
    description: 'Veriye dayalı, ölçülebilir bir yol haritası çıkarıyoruz.',
  },
  {
    number: '03',
    title: 'Üretim',
    description: 'İçerik, kampanya ve deneyimleri hayata geçiriyoruz.',
  },
  {
    number: '04',
    title: 'Aktivasyon',
    description: 'Doğru kanallarda, doğru zamanda yayına alıyoruz.',
  },
  {
    number: '05',
    title: 'Ölçüm',
    description: 'Sonuçları analiz edip, sürekli optimize ediyoruz.',
  },
];

export default function Process() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="process" ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="font-serif text-5xl text-charcoal mb-16"
        >
          Nasıl İlerleriz
        </motion.h2>

        {/* Desktop Timeline */}
        <div className="hidden lg:block relative">
          <div className="absolute top-12 left-0 right-0 h-0.5 bg-gray-200"></div>
          
          <div className="grid grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="relative"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-6 h-6 bg-charcoal rounded-full mb-6 relative z-10"></div>
                  <span className="font-sans font-bold text-sm text-charcoal mb-2">
                    {step.number}
                  </span>
                  <h3 className="font-sans font-semibold text-base text-charcoal mb-2">
                    {step.title}
                  </h3>
                  <p className="font-sans text-sm text-gray-medium leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Mobile Timeline */}
        <div className="lg:hidden space-y-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, x: -30 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="flex gap-6"
            >
              <div className="flex flex-col items-center">
                <div className="w-6 h-6 bg-charcoal rounded-full flex-shrink-0"></div>
                {index < steps.length - 1 && (
                  <div className="w-0.5 h-full bg-gray-200 mt-2"></div>
                )}
              </div>
              <div className="pb-8">
                <span className="font-sans font-bold text-sm text-charcoal">
                  {step.number}
                </span>
                <h3 className="font-sans font-semibold text-base text-charcoal mt-1 mb-2">
                  {step.title}
                </h3>
                <p className="font-sans text-sm text-gray-medium leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-center font-sans text-sm text-gray-medium mt-12"
        >
          Ortalama süre: 2–6 hafta
        </motion.p>
      </div>
    </section>
  );
}
